<template>
  <div class="hidden-sm-and-up">
    <div class="mobile_nav_wrap">
      <div class="navbar_left" @click="gobackHome">
        <img src="@/assets/img/home/logo.png" alt="万知创造..." />
      </div>
      <div class="navbar_right">
        <div class="nav_btns" @click="moveMenu">
          <i :class="menuShow ? 'el-icon-close' : 'el-icon-menu'"></i>
        </div>
      </div>
    </div>
    <Affix>
      <div class="nav_menu" ref="menu" :class="{ 'menu-open': menuShow }">
        <!-- 首页 -->
        <router-link
          class="menu_item"
          to="/home"
          :class="currentActive === 0 ? 'active' : ''"
          @click.native="closeMainMenu"
        >
          <i class="menu-icon el-icon-house"></i>
          <span>首頁</span>
        </router-link>

        <!-- 关于万知 -->
        <div
          class="menu_item has-submenu"
          @click="toggleSubMenu('fire')"
          :class="currentActive === 4 ? 'active' : ''"
        >
          <i class="menu-icon el-icon-info"></i>
          <span>關於萬知</span>
          <i
            class="submenu-arrow el-icon-arrow-right"
            :class="{ rotate: fireShow }"
          ></i>
        </div>
        <transition name="slide">
          <div class="item_optionss" v-show="fireShow">
            <router-link to="/fivenav/1" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-document"></i>
              <span>萬知介紹</span>
            </router-link>
            <router-link to="/fivenav/2" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-phone"></i>
              <span>聯繫萬知</span>
            </router-link>
          </div>
        </transition>

        <!-- 智慧服务 -->
        <div
          class="menu_item has-submenu"
          @click="toggleSubMenu('zhihui')"
          :class="currentActive === 3 ? 'active' : ''"
        >
          <i class="menu-icon el-icon-cpu"></i>
          <span>智慧服務</span>
          <i
            class="submenu-arrow el-icon-arrow-right"
            :class="{ rotate: zhihuiShow }"
          ></i>
        </div>
        <transition name="slide">
          <div class="item_optionss zhihui-submenu" v-show="zhihuiShow">
            <router-link to="/intelligent/1" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-coordinate"></i>
              <span>軟件開發</span>
            </router-link>
            <router-link to="/intelligent/2" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-connection"></i>
              <span>AI 賦能</span>
            </router-link>
            <router-link to="/intelligent/3" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-document-copy"></i>
              <span>投審稿系統</span>
            </router-link>
            <router-link to="/intelligent/4" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-edit"></i>
              <span>智能編排校</span>
            </router-link>
            <router-link to="/intelligent/5" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-share"></i>
              <span>智能協作平臺</span>
            </router-link>
          </div>
        </transition>

        <!-- 科研服务 -->
        <div
          class="menu_item has-submenu"
          @click="toggleSubMenu('zhishi')"
          :class="currentActive === 2 ? 'active' : ''"
        >
          <i class="menu-icon el-icon-reading"></i>
          <span>科研服務</span>
          <i
            class="submenu-arrow el-icon-arrow-right"
            :class="{ rotate: zhishiShow }"
          ></i>
        </div>
        <transition name="slide">
          <div class="item_options" v-show="zhishiShow">
            <router-link to="/scientific/1" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-data-analysis"></i>
              <span>實驗服務</span>
            </router-link>
            <router-link to="/scientific/2" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-s-promotion"></i>
              <span>課題服務</span>
            </router-link>
            <!-- <router-link to="/research/3" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-global"></i>
              <span>國際高端刊投稿服務</span>
            </router-link> -->
          </div>
        </transition>

        <!-- 国际业务 -->
        <div
          class="menu_item has-submenu"
          @click="toggleSubMenu('center')"
          :class="currentActive === 6 ? 'active' : ''"
        >
          <i class="menu-icon el-icon-office-building"></i>
          <span>國際業務</span>
          <i
            class="submenu-arrow el-icon-arrow-right"
            :class="{ rotate: centerShow }"
          ></i>
        </div>
        <transition name="slide">
          <div class="item_option center-submenu" v-show="centerShow">
            <router-link to="/international/1" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-s-grid"></i>
              <span>國際會議</span>
            </router-link>
            <router-link to="/international/2" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-school"></i>
              <span>國際教育</span>
            </router-link>
            <router-link to="/international/3" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-news"></i>
              <span>自主國際期刊</span>
            </router-link>
            <router-link to="/international/4" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-star-on"></i>
              <span>國際高端期刊</span>
            </router-link>
            <router-link to="/international/5" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-s-custom"></i>
              <span>國際高端期刊聯合</span>
            </router-link>
            <router-link to="/international/6" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-document"></i>
              <span>國際專著出書</span>
            </router-link>
            <router-link to="/international/7" @click.native="closeMainMenu">
              <i class="submenu-icon el-icon-s-management"></i>
              <span>譯著</span>
            </router-link>
          </div>
        </transition>

        <!-- 投资 -->
        <router-link
          class="menu_item"
          to="/investment"
          :class="currentActive === 7 ? 'active' : ''"
          @click.native="closeMainMenu"
        >
          <i class="menu-icon el-icon-coin"></i>
          <span>投資</span>
        </router-link>
      </div>
    </Affix>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuShow: false,
      productShow: false,
      centerShow: false,
      fireShow: false,
      zhishiShow: false,
      zhihuiShow: false
    };
  },
  props: {
    currentActive: {
      default: 0,
      type: Number
    }
  },
  methods: {
    moveMenu() {
      this.menuShow = !this.menuShow;
      // 禁止/允许 body 滚动
      document.body.style.overflow = this.menuShow ? "hidden" : "auto";
    },
    toggleSubMenu(menuType) {
      // 根据菜单类型切换对应子菜单
      switch (menuType) {
        case "fire":
          this.fireShow = !this.fireShow;
          // 关闭其他子菜单
          if (this.fireShow) {
            this.zhihuiShow = false;
            this.zhishiShow = false;
            this.centerShow = false;
          }
          break;
        case "zhihui":
          this.zhihuiShow = !this.zhihuiShow;
          if (this.zhihuiShow) {
            this.fireShow = false;
            this.zhishiShow = false;
            this.centerShow = false;
          }
          break;
        case "zhishi":
          this.zhishiShow = !this.zhishiShow;
          if (this.zhishiShow) {
            this.fireShow = false;
            this.zhihuiShow = false;
            this.centerShow = false;
          }
          break;
        case "center":
          this.centerShow = !this.centerShow;
          if (this.centerShow) {
            this.fireShow = false;
            this.zhihuiShow = false;
            this.zhishiShow = false;
          }
          break;
      }
    },
    closeMainMenu() {
      this.menuShow = false;
      this.fireShow = false;
      this.zhihuiShow = false;
      this.zhishiShow = false;
      this.centerShow = false;
      document.body.style.overflow = "auto";
    },
    gobackHome() {
      this.$router.replace("/home").catch(v => {});
      this.closeMainMenu();
    }
  },
  beforeDestroy() {
    // 组件销毁时恢复 body 滚动
    document.body.style.overflow = "auto";
  }
};
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56px;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 0 10px;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .navbar_left {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    min-width: 0;
    overflow: hidden;

    img {
      width: 236px;
      max-width: 89%;
      height: 67px;
      max-height: 86%;
      object-fit: contain;
      display: block;
    }
  }

  .navbar_right {
    flex: 0 0 56px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;

    .nav_btns {
      width: 44px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 50%;
      transition: background 0.3s;

      &:active {
        background: rgba(0, 0, 0, 0.1);
      }

      i {
        font-size: 26px;
        color: #333;
      }
    }
  }
}

.active {
  color: #f39c00 !important;
  font-weight: bold;
}

.nav_menu {
  position: fixed;
  width: 100%;
  max-height: 0;
  left: 0;
  right: 0;
  top: 56px;
  padding-bottom: 0;
  box-sizing: border-box;
  background: #eff0f1;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  z-index: 999;
  transition: max-height 0.4s ease-in-out;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &.menu-open {
    max-height: calc(100vh - 56px);
  }

  .menu_item {
    width: 100%;
    min-height: 50px;
    font-size: 0.95rem;
    font-weight: 600;
    background: #eff0f1;
    color: #1c212d;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: background 0.3s;

    &:active {
      background: rgba(0, 0, 0, 0.05);
    }

    .menu-icon {
      width: 24px;
      margin-right: 10px;
      font-size: 18px;
      color: #1a63c4;
    }

    span {
      flex: 1;
    }

    .submenu-arrow {
      font-size: 14px;
      color: #999;
      transition: transform 0.3s;

      &.rotate {
        transform: rotate(90deg);
      }
    }
  }

  .item_options {
    width: 100%;
    background: #fff;
    overflow: hidden;

    a {
      display: flex;
      align-items: center;
      width: 100%;
      color: #666;
      min-height: 45px;
      padding: 12px 20px 12px 54px;
      font-size: 0.85rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.03);

      &:active {
        background: rgba(0, 0, 0, 0.03);
      }

      .submenu-icon {
        width: 20px;
        margin-right: 8px;
        font-size: 14px;
        color: #1a63c4;
      }
    }
  }

  .item_option {
    width: 100%;
    background: #fff;
    overflow: hidden;

    &.center-submenu {
      max-height: 500px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    a {
      display: flex;
      align-items: center;
      width: 100%;
      color: #666;
      min-height: 45px;
      padding: 12px 20px 12px 54px;
      font-size: 0.85rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.03);

      &:active {
        background: rgba(0, 0, 0, 0.03);
      }

      .submenu-icon {
        width: 20px;
        margin-right: 8px;
        font-size: 14px;
        color: #1a63c4;
      }
    }
  }

  .item_optionss {
    width: 100%;
    background: #fff;
    overflow: hidden;

    &.zhihui-submenu {
      max-height: 300px;
    }

    a {
      display: flex;
      align-items: center;
      width: 100%;
      color: #666;
      min-height: 45px;
      padding: 12px 20px 12px 54px;
      font-size: 0.85rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.03);

      &:active {
        background: rgba(0, 0, 0, 0.03);
      }

      .submenu-icon {
        width: 20px;
        margin-right: 8px;
        font-size: 14px;
        color: #1a63c4;
      }
    }
  }
}

// 滑动动画
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
  opacity: 1;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}

// 滚动条样式
.nav_menu::-webkit-scrollbar {
  width: 4px;
}

.nav_menu::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.nav_menu::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}

.nav_menu::-webkit-scrollbar-thumb:hover {
  background: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/MobileNavBar.vue